/* LeMerch: the quick view (cart cross-sells "+", product cards) builds its content from the product page
   blocks and pulls the quantity selector out of the buy buttons. Back inside, the quantity sits left and
   "In die Tasche" right in the sticky bar, as on the product page
   (component-limited-drop-pdp.css, "Quantity next to the add-to-cart button"). */
(() => {
  if (window.lmQuickView) return;
  window.lmQuickView = true;

  const fix = () => {
    document
      .querySelectorAll('.product-quick-view product-block-buy-buttons.product-details__buy-buttons--inline-quantity')
      .forEach((buyButtons) => {
        const details = buyButtons.closest('.product__details');
        const quantity = details && details.querySelector(':scope > .product-details__quantity');
        if (quantity && !buyButtons.contains(quantity)) buyButtons.prepend(quantity);
      });
  };

  let queued = false;
  new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      fix();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
